import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MOBILE_MAX_WIDTH, TABLET_MAX_WIDTH } from '../config';

// @ts-ignore-next-line
@Component

export default class GlobalMixin extends Vue {
    isTablet(): boolean {
        return window.innerWidth < TABLET_MAX_WIDTH && window.innerWidth >= MOBILE_MAX_WIDTH;
    }
    isMobile(): boolean {
        return window.innerWidth < MOBILE_MAX_WIDTH;
    }
    isDesktop(): boolean {
        return window.innerWidth >= MOBILE_MAX_WIDTH;
    }
    // @ts-ignore-next-line
    requireFwImage(path: string): any {
        let image = null;
        try {
            image = require(`../static/images/${path}`);
        } catch (e) {
            console.log(e);
        }
        return image;
    }
};
